import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

/**
 * Panel tipo burbuja de vidrio con bordes iluminados.
 * Se despliega debajo de una tarjeta informativa y muestra el detalle del dato.
 */
export const InfoBubble = ({ open, title, note, items = [], cta, testId = 'info-bubble' }) => {
  const navigate = useNavigate();

  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          data-testid={testId}
          initial={{ opacity: 0, height: 0, y: -6 }}
          animate={{ opacity: 1, height: 'auto', y: 0 }}
          exit={{ opacity: 0, height: 0, y: -6 }}
          transition={{ duration: 0.28, ease: 'easeOut' }}
          className="overflow-hidden"
        >
          <div className="glass-bubble mt-2 p-3 space-y-2">
            {title && <p className="text-[11px] font-semibold uppercase tracking-wide text-primary">{title}</p>}
            <div className="grid gap-1.5">
              {items.map((it) => (
                <button
                  key={it.label}
                  onClick={(e) => { e.stopPropagation(); if (it.to) navigate(it.to); }}
                  data-testid={`${testId}-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                  className="group flex items-center justify-between gap-3 px-2.5 py-2 rounded-xl bg-primary/5 hover:bg-primary/12 border border-primary/15 dark:bg-white/5 dark:hover:bg-white/10 dark:border-white/10 transition-colors text-left"
                >
                  <span className="text-xs text-foreground/90 truncate">{it.label}</span>
                  <span className="flex items-center gap-1 shrink-0">
                    <span className="text-xs font-bold tabular-nums">{it.value}</span>
                    {it.to && <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-70 transition-opacity" />}
                  </span>
                </button>
              ))}
            </div>
            {note && <p className="text-[11px] text-muted-foreground leading-relaxed">{note}</p>}
            {cta && (
              <button
                onClick={(e) => { e.stopPropagation(); navigate(cta.to); }}
                data-testid={`${testId}-cta`}
                className="w-full mt-1 px-3 py-2 rounded-full bg-primary text-primary-foreground text-xs font-semibold inline-flex items-center justify-center gap-1.5 hover:opacity-90 transition-opacity"
              >
                {cta.label} <ArrowUpRight className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InfoBubble;
